import {TableColumnGroups} from "../../commons/angular/models/table-column-option.model";

// columns.id isn't offered where it only toggles the pinned ID cell

export const ROUTES_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Route Info',
    labelPrefix: 'ROUTES_VIEW_ROUTES_SETTINGS.',
    columnIds: {
      id: 'col-route-id',
      status: 'col-status',
      agent: 'col-agent',
      vehicle: 'col-vehicle',
      timeWindow: 'col-time-window',
      duration: 'col-duration',
      distance: 'col-distance',
      services: 'col-services',
      tasksCount: 'col-tasks-count',
      pickupStops: 'col-pickup-stops',
      destinationStops: 'col-destination-stops',
      proNumber: 'col-pro-number',
      relations: 'col-relations',
      referenceIds: 'col-reference-ids',
      accounts: 'col-accounts',
      accountsExternalIds: 'col-accounts-external-ids',
      pickingHour: 'col-picking-hour',
      trips: 'col-trips',
      skills: 'col-skills',
      tags: 'col-tags',
      // Rendered with the vehicle column's class, so it shares that column's position
      resource: 'col-vehicle',
      plateNumber: 'col-plate-number',
      assistant: 'col-assistant',
      price: 'col-price',
      value: 'col-value',
      progress: 'col-progress'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-load-weight',
      volume: 'col-load-volume',
      packages: 'col-load-packages',
      pallets: 'col-load-pallets',
      spots: 'col-load-spots',
      value: 'col-load-value'
    }
  },
  capacity: {
    title: 'Capacity Bar',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-capacity-weight',
      volume: 'col-capacity-volume',
      pallets: 'col-capacity-pallets'
    }
  }
};

export const SERVICES_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Service Info',
    labelPrefix: 'DELIVERIES_TABLE_COLUMNS.',
    columnIds: {
      account: 'col-account',
      contact: 'col-contact',
      proNumber: 'col-pro-number',
      location: 'col-location',
      timeWindow: 'col-time-window',
      serviceTime: 'col-service-time',
      route: 'col-route',
      resource: 'col-resource',
      packages: 'col-packages',
      tags: 'col-tags',
      skills: 'col-skills',
      price: 'col-price',
      relations: 'col-relations'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-load-weight',
      volume: 'col-load-volume',
      packages: 'col-load-packages',
      pallets: 'col-load-pallets',
      spots: 'col-load-spots',
      value: 'col-load-value'
    }
  }
};

export const RESOURCES_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Resources Info',
    labelPrefix: 'ROUTES_VIEW_RESOURCES_SETTINGS.',
    columnIds: {
      vehicleType: 'col-vehicle',
      logisticVehicles: 'col-logistic-vehicle',
      timeWindow: 'col-time-window',
      tags: 'col-tags',
      labels: 'col-labels',
      routesCount: 'col-routes-count',
      routeNames: 'col-route-names',
      retrips: 'col-retrips',
      totalDuration: 'col-total-duration'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-load-weight',
      volume: 'col-load-volume',
      packages: 'col-load-packages',
      spots: 'col-load-spots',
      pallets: 'col-load-pallets',
      value: 'col-load-value'
    }
  },
  capacity: {
    title: 'Capacity Bar',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-capacity-weight',
      volume: 'col-capacity-volume',
      pallets: 'col-capacity-pallets'
    }
  }
};

export const ROUTE_DRILLDOWN_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Stops Info',
    labelPrefix: 'ROUTES_VIEW_ROUTE_SETTINGS.',
    columnIds: {
      status: 'col-status',
      serviceType: 'col-service-type',
      account: 'col-account',
      contact: 'col-contact',
      address: 'col-address',
      timeWindow: 'col-time-window',
      eta: 'col-eta',
      etd: 'col-etd',
      serviceTime: 'col-service-time',
      sla: 'col-sla',
      packages: 'col-packages',
      labels: 'col-labels',
      price: 'col-price',
      relations: 'col-relations',
      proNumber: 'col-pro-number',
      referenceIds: 'col-reference-ids',
      programType: 'col-program-type',
      depotExternalId: 'col-depot-external-id'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-weight',
      volume: 'col-volume',
      pallets: 'col-pallets',
      spots: 'col-spots'
    }
  }
};
